<template>
  <div ref="dropdownRef" class="relative inline-block text-left w-48 sm:w-full sm:max-w-xs">
    <!-- Aktuelle Auswahl -->
    <button
  @click="toggleDropdown"
  @mouseenter="isHovered = true"
  @mouseleave="isHovered = false"
  class="flex items-center sm:w-full sm:max-w-xs w-auto truncate px-2 sm:px-4 py-2 bg-transparent cursor-pointer font-semibold 
         text-skin-b-list-mute hover:text-skin-b-list-base hover:bg-slate-300/40 focus:outline-none"
>
  <!-- Icon Section -->
  <div class="hidden sm:flex items-center flex-shrink">
    <IconSort
      v-if="isHovered"
      class="w-6 h-6 mr-2 text-skin-b-list-base transition-opacity duration-300"
    />
  </div>
  <!-- Label Section -->
  <span class="truncate text-left flex-shrink">{{ selectedOption?.label || placeholder }}</span>
</button>


    <!-- Dropdown-Menü -->
    <div
      v-if="isOpen"
      class="absolute mt-2 w-full bg-white border-2 border-skin-b-list-bord rounded-md shadow-lg z-10 overflow-hidden"
    >
      <ul class="overflow-y-auto" :style="{ maxHeight: maxDropdownHeight }">
        <li
          v-for="(option, index) in this.filteredOptions"
          :key="option.value"
          @click="selectOption(option)"
          @mouseenter="hoverIndex = index"
          @mouseleave="hoverIndex = -1"
          class="flex items-center px-4 py-2 cursor-pointer text-skin-b-list-mute hover:text-skin-b-list-base"
          :class="{ 'font-semibold bg-skin-active128/10': modelValue === option.value,
                    'font-semibold bg-slate-300/20': option.highlight&&modelValue != option.value,
                    'bg-slate-300/40': hoverIndex === index&&modelValue != option.value
                  }"
        >
        <IconSelected
            v-if="modelValue === option.value"
            class="w-6 h-6 mr-2"
          />
          <span>{{ option.label }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import { ref, toRefs, computed, onMounted, onBeforeUnmount } from 'vue'
import IconSelected from '@/components/icons/IconSelected.vue'
import IconSort from '@/components/icons/IconSort.vue'

export default {
  name: 'CustomDropdown',
  components: {
    IconSelected, IconSort, 
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { modelValue, options } = toRefs(props);
    const isOpen = ref(false);
    const hoverIndex = ref(-1);
    const isHovered = ref(false);
    const dropdownRef = ref(null);
    const maxDropdownHeight = ref(`${window.innerHeight - 220}px`);

    const updateMaxDropdownHeight = () => {
      maxDropdownHeight.value = `${window.innerHeight - 220}px`;
    };

    const selectedOption = computed(() =>
      options.value.find(option => option.value === modelValue.value)
    );
    const filteredOptions = computed(() =>
      options.value.filter(option => option.show)
    );

    const toggleDropdown = () => {
      isOpen.value = !isOpen.value;
    };

    const closeDropdown = () => {
      isOpen.value = false;
    };

    const selectOption = option => {
      emit('update:modelValue', option.value);
      closeDropdown();
    };

    const handleClickOutside = event => {
      if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
        closeDropdown();
      }
    };

    const handleKeydown = event => {
      if (event.key === 'ArrowDown') {
        hoverIndex.value = (hoverIndex.value + 1) % filteredOptions.value.length;
      } else if (event.key === 'ArrowUp') {
        hoverIndex.value =
          (hoverIndex.value - 1 + filteredOptions.value.length) %
          filteredOptions.value.length;
      } else if (event.key === 'Enter' && hoverIndex.value >= 0) {
        selectOption(filteredOptions.value[hoverIndex.value]);
      } else if (event.key === 'Escape') {
        closeDropdown();
      }
    };

    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
      document.addEventListener('keydown', handleKeydown);
      window.addEventListener('resize', updateMaxDropdownHeight);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('keydown', handleKeydown);
      window.removeEventListener('resize', updateMaxDropdownHeight);
    });

    return {
      isOpen,
      hoverIndex,
      dropdownRef,
      maxDropdownHeight,
      selectedOption,
      filteredOptions,
      isHovered,
      toggleDropdown,
      selectOption,
      closeDropdown,
      updateMaxDropdownHeight,
    };
  },
};
</script>

<style scoped>
button {
  display: flex;
  align-items: center;
  width: 100%;
}

button .flex {
  display: flex;
  align-items: center;
}

button:hover .IconSort {
  opacity: 1;
  transform: translateX(0);
}

.IconSort {
  opacity: 0;
  transform: translateX(-5px);
  transition: opacity 0.3s, transform 0.3s;
}

.IconStacks {
  transition: opacity 0.3s, transform 0.3s;
}

button:hover .IconStacks {
  opacity: 0;
  transform: translateX(5px);
}
</style>


